module.exports = __webpack_public_path__ + "assets/img/contact_banner.29c64c9c.png";